/**
 * this is where the main controls to enable or disable the feature flag
 * for sponsorships thresholds
 
 * to remove the feature flag code, grep for:
 * SPONSORSHIPS_THRESHOLD_FEATURE_POST_LAUNCH
 * each spot where that text is located has some intructions on how to remove
 * the feature flag code
 */

// add station IDs here if you want to only allow specific accounts for testing
const ALLOW_LIST_WEB_STATION_IDS: string[] = ['a74e78'];

// set this to `true` once you're ready to turn this on for EVERYONE
const ENABLE_SPONSORSHIPS_THRESHOLD = false;

export function getIsSponsorshipsThresholdEnabled(webStationId: string | null) {
  return (
    ENABLE_SPONSORSHIPS_THRESHOLD ||
    (webStationId && ALLOW_LIST_WEB_STATION_IDS.includes(webStationId))
  );
}
